import { Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import {
    HttpClient,
    HttpHeaders,
    HttpHeaderResponse,
    HttpParams,
} from '@angular/common/http'

import { environment } from '../../environments/environment'

@Injectable()
export class HttpServiceHelper {
    constructor(private http: HttpClient) {}

    public httpGetRequest<T>(url: string, queryString?: HttpParams) {
        // let profile = this.authService.getAccount().idTokenClaims;
        // let email = profile.email;
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'Ocp-Apim-Subscription-Key': `${environment.srecApiKey}`,
        })
        let httpOptions = {}

        httpOptions =
            queryString !== undefined && queryString.keys().length > 0
                ? (httpOptions = { headers: headers, params: queryString })
                : (httpOptions = { headers: headers })

        return this.http.get<T>(url, httpOptions).pipe(
            map((response: T) => {
                return response
            }),
            catchError((err) => {
                return throwError(err)
            })
        )
    }

    public httpPostRequest<T>(url: string, data: T) {
        // let profile = this.authService.getAccount().idTokenClaims;
        // let email = profile.email;
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'Ocp-Apim-Subscription-Key': `${environment.srecApiKey}`,
        })
        let httpOptions = new HttpHeaderResponse({ headers: headers })

        return this.http.post<T>(url, data, httpOptions).pipe(
            map((response: T) => {
                return response
            }),
            catchError((err) => {
                return throwError(err)
            })
        )
    }

    public httpGetRequestNoAuth<T>(url: string): Observable<T> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'Ocp-Apim-Subscription-Key': `${environment.srecApiKey}`,
        })
        let httpOptions = new HttpHeaderResponse({ headers: headers })

        //httpOptions = queryString !== undefined && queryString.keys().length > 0 ?  httpOptions = { headers: headers, params: queryString } : httpOptions = {headers: headers };

        return (
            this.http
                .get<T>(url, httpOptions)
                // .pipe(
                //   retry(1),
                //   catchError(this.handleError)
                // );
                .pipe(
                    map((response: T) => {
                        return response
                    }),
                    catchError((err) => {
                        return throwError(err)
                    })
                )
        )
    }

    public httpPostRequestNoAuth<T>(url: string, data: T): Observable<T> {
        let headers = new HttpHeaders({
            'Content-Type': 'application-json',
            'Ocp-Apim-Subscription-Key': `${environment.srecApiKey}`,
        })
        let httpOptions = new HttpHeaderResponse({ headers: headers })

        return this.http.post<T>(url, data, httpOptions).pipe(
            map((response: T) => {
                return response
            }),
            catchError((err) => {
                return throwError(err)
            })
        )
    }

    public httpPostFormNoAuth<T>(url: string, data: T): Observable<T> {
        let headers = new HttpHeaders({
            Accept: 'application/json',
            'Ocp-Apim-Subscription-Key': `${environment.srecApiKey}`,
        })
        let httpOptions = new HttpHeaderResponse({ headers: headers })

        return this.http.post<T>(url, data, httpOptions).pipe(
            map((response: T) => {
                return response
            }),
            catchError((err) => {
                return throwError(err)
            })
        )
    }

    handleError(error: { error: { message: any }; status: any; message: any }) {
        let errorMessage = ''
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`
        }
        //window.alert(errorMessage);
        console.log(errorMessage)
        return throwError(errorMessage)
    }
}
